import { render, staticRenderFns } from "./CrossMatching.vue?vue&type=template&id=a64f4bf4&scoped=true&"
import script from "./CrossMatching.vue?vue&type=script&lang=js&"
export * from "./CrossMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64f4bf4",
  null
  
)

export default component.exports